var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "logoutContainer"
  }, [_c('v-card', {
    staticClass: "pr-12 pl-12 pt-7 pb-7",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('h3', {
    staticClass: "bold ml-n1 mr-n1",
    staticStyle: {
      "word-break": "break-word"
    }
  }, [_vm._v(" " + _vm._s(_vm.reason) + " ")])]), _c('v-card-text', [_c('v-btn', {
    staticClass: "button mt-2",
    attrs: {
      "data-test-back-to-login": "",
      "x-large": "",
      "block": "",
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": _vm.backToLogin
    }
  }, [_vm._v(" Zurück zum Login ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }